var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useContext, useEffect } from "react";
import { isSKLand } from "../helper";
import { AccountContext } from "./context";
export function useOneAccount() {
    var _a = useContext(AccountContext).state, ready = _a.ready, account = _a.account, loading = _a.loading;
    return {
        ready: ready,
        loading: loading,
        account: account,
    };
}
/**
 * 获取当前用户信息, 如要获取Gryphline用户, 请使用useGlAccount
 *
 * @export
 * @return {*}
 */
export function useAccount() {
    var _a = useContext(AccountContext).state, ready = _a.ready, account = _a.account, loading = _a.loading;
    return {
        ready: ready,
        loading: loading,
        account: account,
    };
}
/**
 * 获取当前Gryphline用户信息
 *
 * @export
 * @return {*}
 */
export function useGlAccount() {
    var _a = useContext(AccountContext).state, ready = _a.ready, account = _a.account, loading = _a.loading;
    return {
        ready: ready,
        loading: loading,
        account: account,
    };
}
/**
 * 获取用户信息
 *
 * @export
 */
export function useFetchOneAccount() {
    var sdkReady = useContext(AccountContext).sdkReady;
    var fetchHgAccount = useFetchAccount();
    var fetchGlAccount = useFetchGlAccount();
    if (sdkReady.SDK_TYPE === "HG") {
        return fetchHgAccount;
    }
    else if (sdkReady.SDK_TYPE === "GL") {
        return fetchGlAccount;
    }
    return useCallback(function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    }, []);
}
/**
 * 获取用户信息, 如要获取Gryphline用户, 请使用useFetchGlAccount
 *
 * @export
 */
export function useFetchAccount() {
    var _a = useContext(AccountContext), dispatch = _a.dispatch, onError = _a.onError, sdkReady = _a.sdkReady;
    return useCallback(function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, accountInfo, account, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            loading: true,
                        });
                        return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = (_a.sent());
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, sdk.Account.API.getInfo()];
                    case 3:
                        accountInfo = _a.sent();
                        account = {
                            hgId: accountInfo.hgId,
                            phone: accountInfo.phone,
                            email: accountInfo.email,
                            // identityName: accountInfo.identityName,
                            // identityNum: accountInfo.identityName,
                            isMinor: accountInfo.isMinor,
                            isLatestUserAgreement: accountInfo.isLatestUserAgreement,
                        };
                        dispatch({
                            ready: true,
                            loading: false,
                            account: account,
                        });
                        return [2 /*return*/, accountInfo];
                    case 4:
                        err_1 = _a.sent();
                        if (sdk.Utils.isSDKError(err_1)) {
                            onError(err_1.message, err_1);
                        }
                        else {
                            onError("", err_1);
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        dispatch({
                            ready: true,
                            loading: false,
                        });
                        return [2 /*return*/, null];
                }
            });
        });
    }, []);
}
/**
 * 获取Gryphline用户信息
 *
 * @export
 */
export function useFetchGlAccount() {
    var _a = useContext(AccountContext), dispatch = _a.dispatch, onError = _a.onError, sdkReady = _a.sdkReady;
    return useCallback(function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, accountInfoRes, account, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            loading: true,
                        });
                        return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = (_a.sent());
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, sdk.user.API.getBasicInfo()];
                    case 3:
                        accountInfoRes = _a.sent();
                        if (accountInfoRes.result && accountInfoRes.data) {
                            account = {
                                hgId: accountInfoRes.data.hgId,
                                displayName: accountInfoRes.data.displayName,
                                nickName: accountInfoRes.data.nickName,
                                email: accountInfoRes.data.email,
                            };
                            dispatch({
                                ready: true,
                                loading: false,
                                account: account,
                            });
                            return [2 /*return*/, account];
                        }
                        onError(accountInfoRes.msg || "", accountInfoRes);
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        onError("", err_2);
                        return [3 /*break*/, 5];
                    case 5:
                        dispatch({
                            ready: true,
                            loading: false,
                        });
                        return [2 /*return*/, null];
                }
            });
        });
    }, []);
}
export function useShowOneLoginDialog() {
    var sdkReady = useContext(AccountContext).sdkReady;
    var showHgLoginDialog = useShowLoginDialog();
    var showGlLoginDialog = useShowGlLoginDialog();
    if (sdkReady.SDK_TYPE === "HG") {
        return showHgLoginDialog;
    }
    else if (sdkReady.SDK_TYPE === "GL") {
        return showGlLoginDialog;
    }
    return useCallback(function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    }, []);
}
/**
 * 显示SDK登录窗口
 *
 * @export
 * @return {*}
 */
export function useShowLoginDialog() {
    var _this = this;
    var _a = useContext(AccountContext), customLoginDialog = _a.customLoginDialog, events = _a.events, sdkReady = _a.sdkReady, dispatch = _a.dispatch;
    return useCallback(function (onSuccess) { return __awaiter(_this, void 0, void 0, function () {
        var sdk;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (customLoginDialog) {
                        console.warn('[@hg/one-account] ShowLoginDialog won\'t work when "customLoginDialog" is enabled.');
                        return [2 /*return*/];
                    }
                    if (isSKLand()) {
                        console.warn("[@hg/one-account] Do NOT show login in skland.");
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = (_a.sent());
                    sdk.User.UI.login({}, function (status, data) {
                        if (status === 0 && data) {
                            dispatch({
                                loading: false,
                                account: data.hgInfo,
                            });
                            events.login.forEach(function (cb) { return cb(data.hgInfo); });
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.hgInfo);
                        }
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [customLoginDialog, events, sdkReady]);
}
export function useShowGlLoginDialog() {
    var _this = this;
    var _a = useContext(AccountContext), customLoginDialog = _a.customLoginDialog, events = _a.events, sdkReady = _a.sdkReady, dispatch = _a.dispatch;
    return useCallback(function (onSuccess) { return __awaiter(_this, void 0, void 0, function () {
        var sdk;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (customLoginDialog) {
                        console.warn('[@hg/one-account] ShowLoginDialog won\'t work when "customLoginDialog" is enabled.');
                        return [2 /*return*/];
                    }
                    if (isSKLand()) {
                        console.warn("[@hg/one-account] Do NOT show login in skland.");
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = (_a.sent());
                    sdk.user.auth({}, function (status, data) {
                        if (status === 0 && data) {
                            dispatch({
                                loading: false,
                                account: data.accountInfo,
                            });
                            events.login.forEach(function (cb) { return cb(data.accountInfo); });
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.accountInfo);
                        }
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [customLoginDialog, events, sdkReady]);
}
/**
 * 登出
 *
 * @export
 */
export function useAccountLogout() {
    var _this = this;
    var _a = useContext(AccountContext), dispatch = _a.dispatch, events = _a.events, sdkReady = _a.sdkReady;
    return useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var sdk, sdk;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSKLand()) {
                        console.warn("[@hg/one-account] Do NOT show login in skland.");
                        return [2 /*return*/];
                    }
                    if (!(sdkReady.SDK_TYPE === "HG")) return [3 /*break*/, 3];
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _a.sent();
                    return [4 /*yield*/, sdk.User.logout()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(sdkReady.SDK_TYPE === "GL")) return [3 /*break*/, 6];
                    return [4 /*yield*/, sdkReady()];
                case 4:
                    sdk = _a.sent();
                    return [4 /*yield*/, sdk.user.API.logout()];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    dispatch({ account: null });
                    // console.log("logout", events)
                    events.logout.forEach(function (cb) { return cb(); });
                    return [2 /*return*/];
            }
        });
    }); }, [sdkReady, dispatch]);
}
/**
 * @deprecated use `useAccountLogout` instead
 *
 * @export
 * @return {*}
 */
export function useLogout() {
    return useAccountLogout();
}
/**
 * 检查是否处于AccountProvider内
 *
 * @export
 * @return {*}
 */
export function useInAccountProvider() {
    return useContext(AccountContext).active;
}
export function useOnOneAccountLogin(onLogin, deps) {
    var events = useContext(AccountContext).events;
    var cb = useCallback(onLogin, deps || []);
    useEffect(function () {
        events.login.push(cb);
        return function () {
            var idx = events.login.indexOf(cb);
            if (idx > -1) {
                events.login.splice(idx, 1);
            }
        };
    }, [events, cb]);
}
/**
 * 监听Account 登录事件处理
 *
 * @export
 * @param {(account: AccountInfo) => void} onLogin
 */
export function useOnAccountLogin(onLogin, deps) {
    return useOnOneAccountLogin(onLogin, deps);
}
/**
 * 监听Gryphline Account 登录事件处理
 *
 * @export
 * @param {(account: GlAccountInfo) => void} onLogin
 */
export function useOnGlAccountLogin(onLogin, deps) {
    return useOnOneAccountLogin(onLogin, deps);
}
/**
 * 监听Account 登出事件处理
 *
 * @export
 * @param {() => void} onLogout
 */
export function useOnAccountLogout(onLogout, deps) {
    var events = useContext(AccountContext).events;
    var cb = useCallback(onLogout, deps || []);
    useEffect(function () {
        events.logout.push(cb);
        return function () {
            var idx = events.logout.indexOf(cb);
            if (idx > -1) {
                events.logout.splice(idx, 1);
            }
        };
    }, [events, cb]);
}
